<ng-content select="[dz-custom]"></ng-content>
<ng-container *ngIf="true">
    <div class="dz-ic">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
            <path d="M17 8l-5-5-5 5M12 3v12" />
        </svg>
    </div>
    <div class="dz-strong">{{ strong }}</div>
    <div class="dz-hint">{{ hint }}</div>
</ng-container>
<input
    #input
    type="file"
    [multiple]="multiple"
    [attr.accept]="accept"
    hidden
    (change)="onInputChange($event)"
    (click)="$event.stopPropagation()"
/>
